import { render, staticRenderFns } from "./captchaInput.vue?vue&type=template&id=770e6e49"
import script from "./captchaInput.vue?vue&type=script&lang=js"
export * from "./captchaInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/centurygame/web-vip/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('770e6e49')) {
      api.createRecord('770e6e49', component.options)
    } else {
      api.reload('770e6e49', component.options)
    }
    module.hot.accept("./captchaInput.vue?vue&type=template&id=770e6e49", function () {
      api.rerender('770e6e49', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/Captcha/captchaInput.vue"
export default component.exports